import { uniq } from "lodash";

import allLocales from "../i18n/all-locales.json";
import { defaultLocale, localeCodeToCountryLanguage, SupportedLocales } from "../i18n/config";
import countries from "../i18n/countries.json";

/**
 * @param localeCode can be string to avoid explicit casts when passing node_locale from Contentful
 * @returns the corresponding {country, language} or a default value
 */
export function getCountryLanguageFromLocaleCode(localeCode: string | SupportedLocales) {
  return (
    localeCodeToCountryLanguage[localeCode as SupportedLocales] ??
    localeCodeToCountryLanguage[SupportedLocales.EN]
  );
}

export function getNodeLocaleFromCountryLanguage(country: string, language: string) {
  const locale = Object.keys(localeCodeToCountryLanguage).find((localeCode) => {
    const { country: c, language: l } = localeCodeToCountryLanguage[localeCode as SupportedLocales];
    return country === c && language === l;
  });

  return locale ?? defaultLocale;
}

export function getAllCountryValues() {
  return uniq(Object.values(localeCodeToCountryLanguage).map(({ country }) => country));
}

export function getSupportedLanguagesForCountry(country: string) {
  return Object.values(localeCodeToCountryLanguage)
    .filter(({ country: c }) => country === c)
    .map(({ language }) => language);
}

export function getNativeLanguageName(code: string) {
  return allLocales.find((locale) => locale.code === code)?.nativeName;
}

const internationalNativeName = "International";

export function getNativeCountryName(code: string) {
  return code === localeCodeToCountryLanguage[SupportedLocales.EN].country
    ? internationalNativeName
    : countries.find((country) => country.iso2.toLowerCase() === code.toLowerCase())?.native ??
        code;
}

export function getHrefLang(localeCode: string) {
  return localeCode === defaultLocale ? "x-default" : localeCode;
}
